import { ChannelName } from '../../../../learnware/LearnwareEnums';
import { MediaChannel } from '../MediaChannel';
export class ChannelBackground extends MediaChannel {
    channelName = ChannelName.Background;
}
